export default __webpack_public_path__ + "static/media/C4.be7ebaae.mp3";